import React from 'react';
import { Modal, Input, message, Spin, Select } from 'antd';
import UploadFile from '../../common/UploadFile';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const Option = Select.Option;
const TextArea = Input.TextArea;

class Update extends React.Component {
    state = {
        loading: false,
        visible: false,
        isEdit: false,
        relationContractList: [],
        saveParams: {},
        fileList: [],
        data: {},
    }

    loadData = () => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvJde,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { data = {} } = res;
                this.setState({
                    data,
                    loading: false,
                }, () => {
                    data && this.loadRelationContractList();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    show = (params) => {
        const saveParams = { ...(params || {}) };
        const { afterAlterContractId } = saveParams;
        saveParams.oldAfterAlterContractId = afterAlterContractId;
        this.loadData();
        this.setState({
            saveParams,
            visible: true,
            isEdit: !!params,
        }, () => {
            const { isEdit } = this.state;
            isEdit && this.loadFileList();
        });
    }

    hide = () => {
        this.setState({
            fileList: [],
            visible: false,
        });
    }

    loadFileList = () => {
        const { isCopy, saveParams: { jdeMainApplyId } } = this.state;
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeApplyFileMetaById,
            data: {
                jdeApplyId: jdeMainApplyId,
                uploadType: 'MAIN_CONTRACT',
            },
            dataType: 'json',
            doneResult: res => {
                const fileList = res.data;
                fileList.forEach((item, index) => {
                    item.response = { fileMetaId: item.fileMateId };
                    item.uid = index;
                    item.isCopy = isCopy;
                });
                this.setState({ fileList });
            }
        };
        $.sendRequest(options);
    }

    loadRelationContractList = () => {
        const { data } = this.state;
        const { jdeCode } = data || {};
        const options = {
            method: 'post',
            url: API_URL.contract.queryRelationJdeId,
            data: { notCode: jdeCode },
            dataType: 'json',
            doneResult: res => {
                const { data = [] } = res;
                this.setState({ relationContractList: data });
            }
        };
        $.sendRequest(options);
    }

    validate = () => {
        const {
            data,
            isEdit,
            fileList,
            saveParams,
        } = this.state;
        const { jdeCode } = data;
        const {
            oldAfterAlterContractId,
            afterAlterContractId,
            alterReason,
        } = saveParams;
        if (!afterAlterContractId) {
            message.warning('请选择变更后JDE主项目号');
            return;
        }
        if (!alterReason) {
            message.warning('请填写变更原因');
            return;
        }
        if (!fileList.length) {
            message.warning('请上传附件');
            return;
        }
        if (!isEdit) {
            fileList.forEach((item, index) => {
                saveParams[`ids[${index}]`] = item.response.fileMetaId;
            });
        }
        
        const params = {
            ...saveParams,
            originalContractCode: jdeCode,
        };
        this.setState({ loading: true });

        const options = {
            method: 'POST',
            url: API_URL.contract.checkJdeMainCode,
            data: { afterAlterContractId },
            dataType: 'json',
            doneResult: res => {
                const { success } = res;
                if (success === '该JDE号已被其他项目复用' && oldAfterAlterContractId != afterAlterContractId) {
                    params.isMultiplex = 1;
                    Modal.confirm({
                        title: <div style={{ marginLeft: 42 }}>该JDE主项目号已被其他项目使用<br />是否仍然确定变更为该JDE主项目号</div>,
                        onOk: () => this.submit(params),
                        onCancel: () => this.setState({ loading: false }),
                    });
                } else {
                    params.isMultiplex = 0;
                    this.submit(params);
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    submit = (params) => {
        const { isEdit } = this.state;
        const url = isEdit ? API_URL.contract.modifyJdeMainApply : API_URL.contract.addJdeMainApply;
        const options = {
            method: 'POST',
            url,
            data: params,
            dataType: 'json',
            doneResult: res => {
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleInputChange = (e, key) => {
        const { saveParams } = this.state;
        saveParams[key] = e.target.value;
        this.setState({ saveParams });
    }

    handleSelectChange = (value, key) => {
        const { saveParams } = this.state;
        saveParams[key] = value;
        this.setState({ saveParams });
    }

    handleUploadChange = (file, fileList) => {
        this.setState({ fileList });
    }

    getDataList = () => {
        const {
            data,
            fileList,
            saveParams,
            relationContractList,
        } = this.state;
        const { jdeCode, investigationName } = data || {};
        const {
            jdeMainApplyId,
            afterAlterContractId,
            alterReason,
        } = saveParams;
        const relationContractOptions = relationContractList.map(i => <Option key={String(i.investigationJdeContractId)}>{i.investigationJdeContractCode}</Option>);
        const asterisk = <span style={{color: 'red'}}>*</span>;

        const uploadParams = {
            uploadType: 'MAIN_CONTRACT',
            path: Date.now(),
        };
        if (jdeMainApplyId) {
            uploadParams.jdeMainApplyId = jdeMainApplyId;
        }
        return (
            <div>
                <li className="modal-item">
                    <div className="item-left">项目简称:</div>
                    <div className="item-right">
                        {investigationName}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">变更前JDE主项目号:</div>
                    <div className="item-right">
                        {jdeCode}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}变更后JDE主项目号:</div>
                    <div className="item-right">
                        <Select
                            placeholder="请选择"
                            style={{width: 182}}
                            onChange={value => this.handleSelectChange(value, 'afterAlterContractId')}
                            onFocus={this.handleFocus}
                            value={afterAlterContractId ? String(afterAlterContractId) : undefined}
                            allowClear={true}
                        >
                            {relationContractOptions}
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}变更原因:</div>
                    <div className="item-right">
                        <TextArea
                            value={alterReason}
                            placeholder="请填写"
                            style={{width: 300, height: 80}}
                            onChange={e => this.handleInputChange(e, 'alterReason')}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}附件:</div>
                    <div className="item-right">
                        <UploadFile
                            data={uploadParams}
                            fileList={fileList}
                            uploadUrl={API_URL.contract.uploadJdeApplyEnclosure}
                            removeUrl={API_URL.contract.deleteJdeCodeEnclosure}
                            onChange={this.handleUploadChange}
                        />
                    </div>
                </li>
            </div>
        )
    }

    render() {
        const { isEdit, visible, loading } = this.state;
        return (
            <Modal
                title={`${!isEdit ? '添加' : '修改'}JDE主项目号变更申请`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.validate}
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <Spin spinning={loading}>
                        <ul className="modal-list">
                            { this.getDataList() }
                        </ul>
                    </Spin>
                </div>
            </Modal>
        )    
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/contractManagement/alterJdeCode/Update.js